export default __webpack_public_path__ + "static/media/community.c21470bd.svg";